import TeamSwitcherIcon from './TeamSwitcherIcon';

export default TeamSwitcherIcon;
